/** 어텀 할인어택 이벤트 - 10월 1일 자정 지났는지 여부 확인 */
export const isAfterTime = () => {
  const hideDate = new Date('2025-11-01T00:00:00+09:00').getTime();
  return Date.now() >= hideDate;
};
